/**
 * UAT DEF-EN-001: the course builder pages (`/admin/learning/courses/build/:id/*`, edit) were open to
 * anyone who typed the URL — a learner saw the enrolment tooling, content editors and reports, and
 * only the API refused the writes. The learner-facing course read already carries `can_manage`
 * (resolved against site / tenant / category / course grants), so the pages ask it and send people
 * without it to the learner course page.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CourseApi } from '@/services/course.service';

export function useRequireCourseManage(courseId: number | string | null | undefined): void {
  const navigate = useNavigate();
  useEffect(() => {
    const id = Number(courseId);
    if (!courseId || Number.isNaN(id)) return;
    let cancelled = false;
    CourseApi.getCourseDetailsForUser(id)
      .then((details) => {
        if (!cancelled && details && details.can_manage === false) {
          navigate(`/user/course-start/${id}`, { replace: true });
        }
      })
      .catch((err: { response?: { status?: number } }) => {
        // 403 / 404: the person may not even see the course — the learner page explains it.
        const status = err?.response?.status;
        if (!cancelled && (status === 403 || status === 404)) navigate(`/user/course-start/${id}`, { replace: true });
      });
    return () => { cancelled = true; };
  }, [courseId, navigate]);
}
